import fetch from 'utils/fetch'
export function getSearchListData (data) {
  return fetch({
    url: `/project/process/getProcessListData`,
    method: 'post',
    data
  })
}
export function getSearchListCount (data) {
  return fetch({
    url: `/project/process/getProcessListCount`,
    method: 'post',
    data
  })
}
export function getProcessInfo (data) {
  return fetch({
    url: `/project/process/getProcessInfo`,
    method: 'post',
    data
  })
}
export function getSubSearchList (data) {
  return fetch({
    url: `/project/search/getSubSearchList`,
    method: 'post',
    data
  })
}
// export function saveSearchParameters (data) {
//   return fetch({
//     url: `${process.env.SEARCH_API}/project/search/saveSearchParameters`,
//     method: 'post',
//     data
//   })
// }
export function modifyExpSearchParameters (data) {
  return fetch({
    url: `${process.env.SEARCH_API}/project/search/modifyExpSearchParameters`,
    method: 'post',
    data
  })
}
export function getExpSearchParameters (data) {
  return fetch({
    url: `${process.env.SEARCH_API}/project/search/getExpSearchParameters`,
    method: 'post',
    data
  })
}
export function deleteSearchParameter (data) {
  return fetch({
    url: `${process.env.SEARCH_API}/project/search/deleteSearchParameter`,
    method: 'post',
    data
  })
}
// db search
export function getCvWorkflowProcedure (data) {
  return fetch({
    url: `/project/process/getCvWorkflowProcedure`,
    method: 'post',
    data
  })
}
export function getCvProcessParamValue (data) {
  return fetch({
    url: `/project/process/getCvProcessParamValue`,
    method: 'post',
    data
  })
}
export function saveProcess (data) {
  return fetch({
    url: `/project/process/saveProcess`,
    method: 'post',
    data
  })
}
export function makeSureComputed (data) {
  return fetch({
    url: `${process.env.PROCESS_API}/pdp/process/start/${data.id}`,
    method: 'post'
  })
}
export function resumeComputed (data) {
  return fetch({
    url: `${process.env.PROCESS_API}/pdp/process/resume/${data.id}`,
    method: 'post'
  })
}
export function pauseComputed (data) {
  return fetch({
    url: `${process.env.PROCESS_API}/pdp/process/pause/${data.id}`,
    method: 'post'
  })
}
export function terminateComputed (data) {
  return fetch({
    url: `${process.env.PROCESS_API}/pdp/process/terminate/${data.id}`,
    method: 'post'
  })
}
export function removeComputed (data) {
  return fetch({
    url: `${process.env.PROCESS_API}/pdp/process/removeFromQueue/${data.id}`,
    method: 'post'
  })
}
export function getStats (data) {
  return fetch({
    url: `${process.env.PROCESS_API}/pdp/system/getStats`,
    method: 'post'
  })
}
export function checkIfExperimentCanBeUsedToBatchInnovationProcess (data) {
  return fetch({
    url: `/project/process/checkIfExperimentCanBeUsedToBatchInnovationProcess`,
    method: 'post',
    data
  })
}
export function getCvProcessDatabase (data) {
  return fetch({
    url: `/project/process/getCvProcessDatabase`,
    method: 'post',
    data
  })
}
export function getCvProcessTheoreticallyDigestionLib (data) {
  return fetch({
    url: `/project/process/getCvProcessTheoreticallyDigestionLib`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/search.js